import React, { Component } from 'react'

import SortableTable from './SortableTable'

import { Link } from 'react-router-dom'

class OtherProjectTable extends Component {
  render () {
    let columns = [
      { id: 'type',
        name: 'Type',
        accessor: d => d.typeShortName,
        displayAccessor: d => <span><i className={d.icon} />&nbsp;{d.typeShortName}</span>,
        filterable: true,
        headerClass: 'medium'
      },
      { id: 'name',
        name: 'Project name',
        accessor: d => d.name,
        displayAccessor: d => <Link to={d.URL()}>{d.name}</Link>,
        filterable: true
      },
      { id: 'technology',
        name: 'Technology',
        accessor: d => d.technology,
        filterable: true
        // headerClass: 'medium'
      },
      { id: 'city',
        name: 'City',
        accessor: d => d.city,
        filterable: true
        // headerClass: 'medium'
      }
    ]

    if (!this.props.simpleListing) {
      columns = columns.concat([
        { id: 'province',
          name: 'Province',
          accessor: d => [d.province, d.provinceCode],
          displayAccessor: d => d.jurisdiction,
          filterable: true,
          headerClass: 'narrow',
          onlyFilterFromStart: true
        },
        { id: 'provincialRiding',
          name: 'Provincial Riding',
          accessor: d => d.provincialRidingName(),
          displayAccessor: d => {
            const riding = d.provincialRiding()
            return riding ? <Link to={riding.URL()}>{riding.name}</Link> : ''
          },
          filterable: true
        },
        { id: 'federalRiding',
          name: 'Federal Riding',
          accessor: d => d.federalRidingName(),
          displayAccessor: d => {
            const riding = d.federalRiding()
            return riding ? <Link to={riding.URL()}>{riding.name}</Link> : ''
          },
          filterable: true
        }
      ])
    }

    const rowFilter = (r) => true

    const projects = this.props.otherProjects
      ? Object.values(this.props.otherProjects)
      : []

    return (
      <div id={this.props.id} className='OtherProjectTable margin-top'>
        <SortableTable
          columns={columns}
          baseSortColumnId={'name'}
          rows={projects}
          rowFilter={rowFilter}
        />
      </div>
    )
  }
}

export default OtherProjectTable



// WEBPACK FOOTER //
// ./src/components/Tables/OtherProjectTable.js